import { formatScheduleDateWithTime } from "@shared/lib/utils/date/formatSchedule";
import {
  ColumnConfig,
  FlexTable,
  FlexTableCell,
  FlexTableRow,
  ResponsiveTable,
  StyledTableRow,
} from "@/components";
import { usePagination } from "@/hooks/pagination/use-pagination";
import { useCustomTranslation } from "@/utils/useCustomTranslation";

import { CourseTypeEnum, SimpleScheduleDto } from "@shared/generated/api/model";
import { useMediaQueryMaxWidth } from "@shared/lib/hooks/use-media-query-max-width";

interface CourseInfoTabProps {
  schedules: SimpleScheduleDto[] | null;
  currentScheduleId: number;
  courseType: CourseTypeEnum;
}

export const CourseInfoTab = ({
  schedules,
  currentScheduleId,
  courseType,
}: CourseInfoTabProps) => {
  const { t } = useCustomTranslation();
  const { isTabletSm } = useMediaQueryMaxWidth();
  const { page, totalPages, paginatedItems, handlePageChange } =
    usePagination<SimpleScheduleDto>({
      totalItems: schedules?.length ?? 0,
      itemsPerPage: 10,
    });

  const currentPageSchedules = schedules ? paginatedItems(schedules) : [];

  const columns: ColumnConfig[] = [
    { width: 80, label: t("session") },
    { width: 300, label: t("class_date_time") },
    { width: 300, label: t("curriculum") },
    { width: 100, label: t("class_resources") },
  ];

  return (
    <FlexTable
      columns={columns}
      page={page}
      totalPages={totalPages}
      onPageChange={handlePageChange}
    >
      {currentPageSchedules.map((schedule) => (
        <>
          {isTabletSm ? (
            <ResponsiveTable
              key={schedule.id}
              isHighlighted={
                courseType === CourseTypeEnum.MULTI &&
                schedule.id === currentScheduleId
              }
            >
              <StyledTableRow>
                {schedule.session.sessionNumber}
                {t("session")}
                {formatScheduleDateWithTime(new Date(schedule.startsAt))}
              </StyledTableRow>
              <StyledTableRow>{schedule.session.title}</StyledTableRow>
            </ResponsiveTable>
          ) : (
            <FlexTableRow
              key={schedule.id}
              isHighlighted={
                courseType === CourseTypeEnum.MULTI &&
                schedule.id === currentScheduleId
              }
            >
              <FlexTableCell width={80}>
                {schedule.session.sessionNumber}
              </FlexTableCell>
              <FlexTableCell width={300}>
                {formatScheduleDateWithTime(new Date(schedule.startsAt))}
              </FlexTableCell>
              <FlexTableCell width={300}>
                {schedule.session.title}
              </FlexTableCell>
              <FlexTableCell width={100}>
                {/* 강의자료 다운로드 버튼 등 */}
              </FlexTableCell>
            </FlexTableRow>
          )}
        </>
      ))}
    </FlexTable>
  );
};
